import _ from "lodash";
import React from "react";
import ReactTable from "react-table";
import {Link} from 'react-router-dom';
import {RedirectButton} from './Buttons';
import IconButton from "components/CustomButtons/IconButton";

//This table component receives an array of rows and values inside are node objects
//I made this to make it reusable across different components
//const Row = ({row_data}) => {
export function processRow(row_data){
  let rowItems = {};

  row_data.tr_head.map((th_value,index) => {
    //swap the key for accessing row values if object has sub selections
    let true_key = th_value.truekey == null ? th_value.accessor : th_value.truekey;
    var column_item
    if (true_key.includes('.')){ 
      try{
        let ks = true_key.split('.');
        column_item = row_data.row_values[ks[0]][ks[1]][ks[2]];
      } catch(err){
        column_item = ""
      }
    } else {
      column_item = row_data.row_values[true_key];
    }

    if (typeof column_item == 'object'){
      //check if value is an object, find leaf through truekey
      //this is due to graphql queries that have sub selections in them
      if (column_item != null){
        column_item = column_item[th_value.accessor];
      }
    }
    
    if (typeof column_item == "boolean" ){
      //check if value is boolean type
      rowItems[th_value.accessor] = (column_item == true) ? "Yes" : "No";
    }
    else if(th_value.accessor == "actions") {
      let serverId = null;

      if (row_data.row_values["pid"])
        serverId = row_data.row_values["pid"];

      //check if value should be a button or a list of buttons
      const actions_object = <div className="actions-right">
          {
            row_data.actions.map((action, index)=>{
              if (row_data.buttons[action].callback) {
                return(
                  <IconButton
                    key={`${th_value.accessor}-${index}`}
                    onClick={row_data.buttons[action].callback}
                    customClass={row_data.buttons[action].style.class}
                    color={row_data.buttons[action].style.color}
                    serverid={row_data.row_values[row_data.buttons[action]['key']]}
                  >
                    {row_data.buttons[action].style.obj}
                    
                  </IconButton>
                )
              }
              else {
                var new_url = row_data.buttons[action].url.replace(':id',row_data.row_values[row_data.buttons[action].key]);
                return (
                  <Link 
                    key={`${th_value.accessor}-${index}`}
                    to={{
                    pathname:`${new_url}`,
                  }}>
                    <IconButton
                      customClass={row_data.buttons[action].style.class}
                      color={row_data.buttons[action].style.color}
                    >
                      {row_data.buttons[action].style.obj}
                    </IconButton>
                  </Link>
                )  
              }
            })
          }
      </div>;
      rowItems["actions"] = (actions_object);
    }
    else{
      // return( <td key={index}>{ column_item } </td>)
      rowItems[th_value.accessor]= column_item;

    }
  })
  return rowItems;
};

class Table extends React.Component {
  
    render() {
      let searchBar = null;
      const {id, rows, header, actions, buttons, hasSearchBar} = this.props.data;
      let tableData = [];
      (!_.isEmpty(rows)) ? 
        rows.map((row_values,index) => {
            let row_data = {
                        row_values:row_values.hasOwnProperty('node') ? row_values.node : row_values,
                        tr_head: header,
                        actions: actions,
                        buttons: buttons
            };
            let row_processed = processRow(row_data);
            tableData.push(row_processed);

        })
      : null;
      let defaultPageSize = tableData.length < 10 ? tableData.length : 10;

      return(
            <ReactTable
              data = {tableData}
              filterable
              columns={header}
              defaultPageSize={(this.props.defaultPageSize != null)? this.props.defaultPageSize : defaultPageSize}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
              manual
              pages={this.props.pages}
              loading={this.props.loading}
              onFetchData={this.props.onFetchData}
            />
      )
    }
}

export default Table;


// WEBPACK FOOTER //
// ./src/views/elements/Table.js